import * as React from 'react';
import { Badge, Button } from 'antd';
import { BellOutlined } from '@ant-design/icons';

interface NotificationsButtonProps {
  count: number;
  onClick?: React.MouseEventHandler<HTMLElement>;
}

const NotificationsButton = React.memo(
  React.forwardRef<HTMLButtonElement, NotificationsButtonProps>(({ count, onClick }, ref) => (
    <Button
      ref={ref}
      className="notification-button"
      type="link"
      onClick={onClick}
      icon={
        <Badge count={count} color="pink">
          <BellOutlined id="newNotificationIndicator" style={{ fontSize: 22 }} />
        </Badge>
      }
    />
  )),
);

NotificationsButton.displayName = 'NotificationsButton';

export default NotificationsButton;
